/**
 * last-chance-badge.js
 *
 * Håndterer tooltip-toggle for "Sidste chance"-badge.
 * CSS klarer hover (desktop) og :focus-visible (tastatur).
 * JS tilføjer click-toggle og Escape-luk (primært til mobil/touch).
 */

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.last-chance-badge__trigger').forEach(function (trigger) {
      var tooltipId = trigger.getAttribute('aria-controls');
      var tooltip = document.getElementById(tooltipId);

      if (!tooltip) return;

      // Click/touch: toggle tooltip
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        tooltip.classList.toggle('last-chance-badge__tooltip--visible', !isOpen);
      });

      // Escape: luk tooltip og returner fokus til knappen
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          tooltip.classList.remove('last-chance-badge__tooltip--visible');
          trigger.focus();
        }
      });

      // Klik udenfor: luk tooltip
      document.addEventListener('click', function (e) {
        if (!trigger.contains(e.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          tooltip.classList.remove('last-chance-badge__tooltip--visible');
        }
      });
    });
  }

  // Kør når DOM er klar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
